import apiService from "../services/apiService";

const loginObj = JSON.parse(localStorage.getItem("auth")) || {};
const ordersUrl = "posapi/GetOrder/";
const orderedProductsUrl = "posapi/GetOrderedProducts/";

export const getOrders = async () => {
  const response = await apiService.get(
    `${ordersUrl}?org=${loginObj.org}&is_archive=false&status=pendingos`
  );
  return response;
};

export const getOrderedProducts = async () => {
  const response = await apiService.get(
    `${orderedProductsUrl}?org=${loginObj.org}&is_archive=false&status=pendingos`
  );
  return response;
};
